import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import useAuth from "../hooks/useAuth";

const ApplicationStatus = () => {
  const [candidatesData, setCandidatesData] = useState([]);
  const { token } = useAuth();
  const URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${URL}/api/candidates-status`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Process data to convert backend response to chart-friendly format
        const rawData = response.data[0]; // Assuming the response is an array with one object
        const chartData = Object.keys(rawData).map((key) => ({
          status: key,
          count: rawData[key],
        }));

        setCandidatesData(chartData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  if (!candidatesData || candidatesData.length === 0) {
    return <div>No data available</div>;
  }

  return (
    <div>
      <center><h1>Applicant Status</h1></center><br/>
      <BarChart
        width={340}
        height={340}
        margin={{ top: 20, right: 0, left: 40, bottom: 0 }}
        data={candidatesData}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="status" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="count" name="Count" fill="#00B4D2" />
      </BarChart>
    </div>
  );
};

export default ApplicationStatus;